import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import VueLazyLoad from 'vue3-lazyload'
import VueBodyClass from 'vue-body-class'
import { store } from './pinia'
import { preloadCriticalModules } from './utils/dynamicImports'

export const Application = createApp(App)
const routes = router.getRoutes()
const vueBodyClass = new VueBodyClass(routes)

// Lazy load analytics after initial render
const loadAnalytics = async () => {
  const { default: VueGtag } = await import('vue-gtag')
  Application.use(
    VueGtag,
    {
      config: {
        id: 'G-KF9WD28V1M',
      },
    },
    router
  )
}

Application.use(router)
  .use(VueLazyLoad, {
    adapter: {
      loaded({ el }) {
        setTimeout(() => el.classList.add('loaded'), 100)
      },
      error(listener) {
        // Suppress false positive errors from lazy loading
        listener.el.src = listener.el.dataset.src || listener.src
      },
    },
  })
  .use(store)
  .mount('#app')

router.beforeEach((to, from, next) => {
  vueBodyClass.guard(to, next)
})

// Preload critical modules when the app starts
preloadCriticalModules()

// Load analytics after a delay to not block initial render
setTimeout(() => {
  loadAnalytics()
}, 2000)
